import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable, filter, first} from "rxjs";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {WebsiteService} from "../../website.service";

@Injectable()
export class OverviewOrderingResolver implements Resolve<null> {

  constructor(
    private _websiteService: WebsiteService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
      this._websiteService.getOverviewWidgetOrder(websiteId)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response) => {
          if (response['success']) {
            const data = response['data'].ordering ? JSON.parse(response.data.ordering) : null;
            resolve(data);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
